export default __webpack_public_path__ + "static/media/frutiger-55roman.107314cb.woff";